import React, { createContext, useState, useContext, useEffect } from 'react';
import { getProfile } from '../api/admin_api';
import { useAuth } from './AuthContext';
import { json } from 'react-router';

export const ProfileContext = createContext();
export const SetProfileContext = createContext();

export function useProfile() {
  return useContext(ProfileContext);
}

export function useSetProfile() {
  return useContext(SetProfileContext)
}

export function ProfileProvider({ children }) {
  const [profile, setProfile] = useState(localStorage.getItem('profileBC'));
  const [pFetchingStatus, setPFetchingStatus] = useState(true);
  const [fFetchingError, setFFetchingError] = useState(null);
  
  const [permission, setPermission] = useState({})
  const { token } = useAuth();

  async function refreshProfile(token) {
    
    return new Promise(async (res,rej) => {
      try {
        setPFetchingStatus(true);
        const profileData = await getProfile(token);
        setProfile(profileData.data.data);
        setPFetchingStatus(false);  
        localStorage.setItem(`profileBC`, JSON.stringify(profileData.data.data))

        res(profileData.data.data)
      } catch (error) {
        rej(error)
      }
      
    })
  }

  async function getPermisison() {
    const filterPerm = profile?.permission?.reduce((acc, cv) => {
      acc[cv.menu] = {}; // Initialize this menu with an empty object
      cv.action.forEach((action_item) => {
        // Now check in the specific menu object if action exists
        if(!acc[cv.menu].hasOwnProperty(action_item)) {
          acc[cv.menu][action_item] = true; // Set this action to true in the menu object
        }
      });
      return acc;
    }, {});

    // setPermission(filterPerm)
    // return filterPerm
  } 
  async function populatePermission(profile) {
    const pp = typeof profile == 'string' ? JSON.parse(profile) : profile
    const filterPerm = pp?.permission?.reduce((acc, cv) => {
      acc[cv.menu] = {}; // Initialize this menu with an empty object
      cv.action.forEach((action_item) => {
        // Now check in the specific menu object if action exists
        if(!acc[cv.menu].hasOwnProperty(action_item)) {
          acc[cv.menu][action_item] = true; // Set this action to true in the menu object
        }
      });
      return acc;
    }, {});
    return filterPerm
  } 

  async function clearProfileData() {
    setProfile(null)
    setPFetchingStatus(true)
    setFFetchingError(null)
    // localStorage.removeItem(`tokenBackoffice`)
    localStorage.removeItem(`profileBC`)
  }

  async function fetchProfileData() {
    if (token && !profile) {
      try {

        const profileData = await getProfile();
        const jsonstringdata = JSON.stringify(profileData.data.data)
        
        localStorage.setItem(`profileBC`, jsonstringdata)

        const permission = await populatePermission(profileData.data.data)
        
        setPermission(permission)
        setProfile(profileData.data.data);
        setPFetchingStatus(false);
      } catch (error) {
        setFFetchingError(true);
      }
    }else{
      const prof = localStorage.getItem(`profileBC`)
      const permission = await populatePermission(prof)
      
      setPermission(permission)
      setProfile(JSON.parse(prof));
      setPFetchingStatus(false)
    }
  }
  useEffect(() => {
    fetchProfileData();
  }, [token, JSON.stringify(profile), JSON.stringify(permission)]);

  return (
    <ProfileContext.Provider value={{ profile, pFetchingStatus, fFetchingError, permission }}>
      <SetProfileContext.Provider value={{ clearProfileData, refreshProfile, getPermisison, setProfile}} >
        {children}
      </SetProfileContext.Provider>
    </ProfileContext.Provider>
  );
}